
export default {
  props: {
    as: { type: String, default: "div" },
    props: { type: Object, default: () => ({}) },
    bevel: { type: Number, default: 4 },
  },
}
